import { Message } from 'common/types';
import { selectUser } from "features/auth/selectors";
import { User } from "common/types";
import { useSelector } from "react-redux";
type Props = {
    message: Message;
};
const RemindMeLater = ({ message }: Props) => {
    const user: User | null = useSelector(selectUser);
    if (message.sender === "SYSTEM") return null;
    return (
        <div>
            <span className="body-17 font-weight-bolder color-gulf-blue">
                We will remind<span>
                     &nbsp;{user?.id===message.sender.id ? "you" :message.sender.firstName} 
                </span> 
                
                <span>
                    &nbsp;to send a follow-up message at a later date
                </span>
            </span>
        </div>
    )
}
export default RemindMeLater;